// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"81a49353","458":"9566a2c8","545":"92a92ee9","615":"7ef355ed","900":"bbec8e99"}[chunkId] + ".chunk.js";
};